export default __webpack_public_path__ + "static/media/pay.17e75627.svg";